window.theme = window.theme || {};

import '../scripts/legacy/index.js';
import { createDebugger, domLog } from '../scripts/utils/debug.js';
window.theme.createDebugger = createDebugger;
window.theme.domLog = domLog;

document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;
